import React, { useState } from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import emailjs from '@emailjs/browser';
export const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    organization: '',
    beds: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<{
    success?: boolean;
    message?: string;
  }>({});
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus({});
    // Prepare the template parameters for EmailJS
    const templateParams = {
      from_name: formData.name,
      from_email: formData.email,
      organization: formData.organization,
      beds: formData.beds,
      message: formData.message
    };
    // Replace these with your actual EmailJS service, template, and user IDs
    // You'll need to sign up at https://www.emailjs.com/ and create a template
    emailjs.send('YOUR_SERVICE_ID',
    // Create a service in EmailJS dashboard
    'YOUR_TEMPLATE_ID',
    // Create an email template in EmailJS
    templateParams, 'YOUR_PUBLIC_KEY' // Your EmailJS public key
    ).then(response => {
      console.log('Email sent successfully:', response);
      setSubmitStatus({
        success: true,
        message: 'Thank you for your interest! We will contact you shortly.'
      });
      // Reset form after submission
      setFormData({
        name: '',
        email: '',
        organization: '',
        beds: '',
        message: ''
      });
    }, error => {
      console.error('Email sending failed:', error);
      setSubmitStatus({
        success: false,
        message: 'Failed to send your message. Please try again later.'
      });
    }).finally(() => {
      setIsSubmitting(false);
    });
  };
  return <section id="contact" className="w-full py-16 md:py-24 px-6 md:px-12 bg-white dark:bg-gray-900" data-id="element-16">
      <div className="max-w-6xl mx-auto" data-id="element-17">
        <div className="text-center mb-12" data-id="element-18">
          <h2 className="text-2xl md:text-3xl font-bold mb-4" data-id="element-19">
            Ready to achieve CMS compliance in under 30 days?
          </h2>
          <p className="text-lg text-gray-600 dark:text-gray-300 max-w-2xl mx-auto" data-id="element-20">
            Schedule a demo to see how RootHealth automates your price
            transparency compliance—with our guarantee.
          </p>
        </div>
        <div className="flex flex-col md:flex-row gap-8" data-id="element-21">
          <div className="md:w-1/2" data-id="element-22">
            <div className="bg-green-50 dark:bg-gray-800 p-8 rounded-lg shadow-md" data-id="element-23">
              <h3 className="text-xl font-bold mb-6" data-id="element-24">
                Our Compliance Guarantee
              </h3>
              <div className="flex items-start mb-6" data-id="element-25">
                <ShieldCheckIcon size={24} className="text-green-500 mr-3 flex-shrink-0 mt-1" data-id="element-26" />
                <p className="text-gray-700 dark:text-gray-300" data-id="element-27">
                  If CMS flags your hospital for non-compliance after using
                  RootHealth, we'll pay the penalty.
                </p>
              </div>
              <div className="space-y-4 mt-8" data-id="element-28">
                <div className="bg-white dark:bg-gray-900 p-6 rounded-lg" data-id="element-29">
                  <h4 className="font-semibold mb-2" data-id="element-30">Fast Implementation</h4>
                  <p className="text-gray-600 dark:text-gray-400" data-id="element-31">
                    Complete CMS compliance in under 30 days—no matter your
                    starting point.
                  </p>
                </div>
                <div className="bg-white dark:bg-gray-900 p-6 rounded-lg" data-id="element-32">
                  <h4 className="font-semibold mb-2" data-id="element-33">Affordable Pricing</h4>
                  <p className="text-gray-600 dark:text-gray-400" data-id="element-34">
                    Simple, bed-based pricing that scales with your
                    organization.
                  </p>
                </div>
                <div className="bg-white dark:bg-gray-900 p-6 rounded-lg" data-id="element-35">
                  <h4 className="font-semibold mb-2" data-id="element-36">Ongoing Support</h4>
                  <p className="text-gray-600 dark:text-gray-400" data-id="element-37">
                    Stay compliant as CMS requirements evolve with our
                    continuous updates.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="md:w-1/2" data-id="element-38">
            <div className="bg-white dark:bg-gray-800 p-8 rounded-lg shadow-md border border-gray-200 dark:border-gray-700" data-id="element-39">
              <h3 className="text-xl font-bold mb-6 text-green-600 dark:text-green-400" data-id="element-40">
                Contact Us
              </h3>
              <form onSubmit={handleSubmit} data-id="element-41">
                <div className="space-y-4" data-id="element-42">
                  <div data-id="element-43">
                    <label htmlFor="name" className="block text-sm font-medium mb-1" data-id="element-44">
                      Name
                    </label>
                    <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-gray-900 dark:text-white" required data-id="element-45" />
                  </div>
                  <div data-id="element-46">
                    <label htmlFor="email" className="block text-sm font-medium mb-1" data-id="element-47">
                      Email
                    </label>
                    <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-gray-900 dark:text-white" required data-id="element-48" />
                  </div>
                  <div data-id="element-49">
                    <label htmlFor="organization" className="block text-sm font-medium mb-1" data-id="element-50">
                      Hospital/Organization
                    </label>
                    <input type="text" id="organization" name="organization" value={formData.organization} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-gray-900 dark:text-white" required data-id="element-51" />
                  </div>
                  <div data-id="element-52">
                    <label htmlFor="beds" className="block text-sm font-medium mb-1" data-id="element-53">
                      Number of beds
                    </label>
                    <input type="number" id="beds" name="beds" value={formData.beds} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-gray-900 dark:text-white" required data-id="element-54" />
                  </div>
                  <div data-id="element-55">
                    <label htmlFor="message" className="block text-sm font-medium mb-1" data-id="element-56">
                      Message
                    </label>
                    <textarea id="message" name="message" value={formData.message} onChange={handleChange} rows={4} className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-gray-900 dark:text-white" data-id="element-57"></textarea>
                  </div>
                  <div className="pt-4" data-id="element-58">
                    <button type="submit" className="w-full px-6 py-3 bg-green-600 hover:bg-green-700 text-white rounded-md text-base font-medium transition-colors" disabled={isSubmitting} data-id="element-59">
                      {isSubmitting ? 'Sending...' : 'Schedule Demo'}
                    </button>
                    {submitStatus.message && <div className={`mt-4 p-3 rounded-md ${submitStatus.success ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`} data-id="element-60">
                        {submitStatus.message}
                      </div>}
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>;
};